import React from "react";

const Loader = () => {
  return (
    <div className="container-loader">
      <div className="loader"></div>
      {/* <div className="loader_v2"></div> */}
    </div>
  );
};

export default Loader;
